<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @openImport="openImport"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="openEditDialogOptions.visible"
      :title="openEditDialogOptions.title"
      :deviceCode="openEditDialogOptions.deviceCode"
      :disabled="openEditDialogOptions.disabled"
      @reload="reload"
      @close="close"
    ></Detail>
    <ImportDrawer
      v-if="visible"
      :visible="visible"
      @reload="reload"
      @close="colseImport"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Detail from '../../detail'
import ImportDrawer from '../import-drawer/index.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Detail, ImportDrawer },
  data() {
    return {
      usePage: true,
      openEditDialogOptions: {
        visible: false,
        deviceCode: '',
      },
      visible: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpPlDeviceListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    close() {
      this.openEditDialogOptions.visible = false
      this.openEditDialogOptions.deviceCode = ''
    },
    openEditPage({ pageType, data = {} }) {
      const types = {
        add: this.$l('dialog_title_add') || '新增产线设备信息信息',
        edit: this.$l('dialog_title_edit') || '编辑产线设备信息信息',
        detail: this.$l('dialog_title_detail') || '产线设备信息详情',
      }
      const { deviceCode = '' } = data
      if (deviceCode) {
        this.openEditDialogOptions.deviceCode = deviceCode
      }
      this.openEditDialogOptions.visible = true
      this.openEditDialogOptions.disabled = pageType == 'detail'
      this.openEditDialogOptions.title = types[pageType]
    },
    openImport() {
      this.visible = true
    },
    colseImport() {
      this.visible = false
    },
  },
}
</script>
